import { __assign } from "tslib";
import { COMPONENT_NAME_PREFIX, CDN_BASE_URL } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "icon";
var observedAttributes = {
    NAME: 'name',
    SRC: 'src',
    LAZY: 'lazy',
    EXTERNAL: 'external',
    EXTERNAL_TYPE: 'external-type',
    VIEWBOX: 'viewbox'
};
var attributes = __assign({}, observedAttributes);
var numbers = {
    LAZY_ROOT_MARGIN: 50,
    DEFAULT_WIDTH: 24,
    DEFAULT_HEIGHT: 24
};
var strings = {
    DEFAULT_NETWORK_BASE_URL: CDN_BASE_URL + "v1/icons/svg"
};
export var ICON_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    numbers: numbers,
    strings: strings
};
export var TYLER_ICON_REGISTRY_KEY = 'tylerIcons';
